import React, { FC } from 'react';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';

export interface CenteredTextProps {
    preTitle: string;
    title: string;
    paragraphOne: string;
    paragraphTwo: string;
}

export const CenteredText: FC<CenteredTextProps> = ({ preTitle, title, paragraphOne, paragraphTwo }) => {

    return (
        <div className="container text-center">
            <div className="custom-container-size-1">
                <Typography fontSize="12" styles={{ spacedText: true }} classes="mb-2">
                    {preTitle}
                </Typography>
                <Typography
                    tagVariant={TypographyTagVariants.h2}
                    appearanceLevel={TypographyAppearanceVariants.level2}
                    classes="mb-3">
                    {title}
                </Typography>
                <div className="text-muted">
                    <Typography classes="mt-3" tagVariant={TypographyTagVariants.p} fontSize="16">
                        {paragraphOne}
                    </Typography>
                    <Typography classes="mt-3" tagVariant={TypographyTagVariants.p} fontSize="16">
                        {paragraphTwo}
                    </Typography>
                </div>
            </div>
        </div>
    );
};
